import * as appConfig from '../../../../../app.config';

import { Component, OnInit, OnDestroy, Input, forwardRef } from '@angular/core';
import { Subscription } from 'rxjs';

import { FormEditorBase } from './../../../../../models/forms/formEditor.base';
import { File } from './../../../../../models/files/files.model';

import { DragulaService } from 'ng2-dragula';
import { FilesService } from './../../../../../shared/services/files.service';
import { EntityService } from './../../../../../shared/services/entity.service';
import { Guid } from './../../../../../shared/utils/guid';
import { Entity } from './../../../../../models/entities/entity.model';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ContainedManyComponent),
  multi: true
};

@Component({
  selector: 'swb-contained-many',
  templateUrl: './contained-many.component.html',
  providers: [DragulaService, CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class ContainedManyComponent extends FormEditorBase implements OnInit, OnDestroy {

  private _onModelChanged: Function;
  private _subscription: Subscription;
  private _guid: string;

  public value: Array<any>;

  constructor(
    private _dragulaService: DragulaService,
    private _filesService: FilesService,
    private _entitiesService: EntityService
  ) {
    super();
    this._guid = Guid.newGuid();
  }

  public ngOnInit(): void {
    this.handleChosenFiles();
    this.handleChosenEntities();


    this._subscription = this._dragulaService.dropModel().subscribe((dragula: any) => {
      dragula.targetModel.forEach((item: File, order: number) => {
        if (!item._joinData) {
          item._joinData = {};
        }
        item._joinData.entityorder = order;
      });
      this._onModelChanged(dragula.targetModel);
    });
  }

  public uploaded($event) {
    if ($event[1] && $event[1].file) {
      const file = $event[1].file;


      const uploadedFile = new File({
        id: file.id,
        file_fullname: file.file_fullname,
        file_name: file.file_name,
        file_type: file.file_type,
        file_size: file.file_size,
        extension: file.extension,
        is_image: file.is_image,
        is_resizable: file.is_resizable,
        _joinData: {
          'id': file.id,
          'entityorder': 999
        }
      });

      // update the model so we can see the new file
      this.value.push(uploadedFile);
    }
  }

  public registerOnChange(fn: Function): void {
    this._onModelChanged = fn;
  }

  public registerOnTouched(fn: Function): void {
    // noop
  }

  public writeValue(value: Array<any>) {
    value.forEach(file => {
      appConfig.languages.forEach(lang => {
        delete file['description_' + lang];
      });
    });
    this.value = value;
  }

  public getFileStyle(file: File): any {
    if (!file || !file.file_fullname) { return; }

    if (file.is_image) {
      if (file.is_resizable) {
        return {
          'background-image': 'url(' + appConfig.apiUrl + appConfig.mediaFolder + '460x460_' + file.file_fullname + ')'
        };
      }
      return {
        'background-image': 'url(' + appConfig.apiUrl + appConfig.mediaFolder + file.file_fullname + ')'
      };
    }

    return {};
  }

  public remove(i: number) {
    this.value.splice(i, 1);
    this._onModelChanged(this.value);
  }

  public browse(): void {
    const browseConfig = { guid: this._guid, multiple: true, imgOnly: this.field.imgOnly, open: true };
    this._filesService.toggleBrowser(browseConfig);
  }

  public ngOnDestroy(): void {
    if (this._dragulaService.find('entities') !== undefined) { this._dragulaService.destroy('entities'); }
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }

  private handleChosenFiles(): void {
    this._subscription = this._filesService.filesChosen$.subscribe((fileResponse: { files: File[], guid: string }) => {
      if (fileResponse.guid === this._guid) {
        fileResponse.files.forEach((entity, index) => {
          appConfig.languages.forEach(lang => {
            delete entity['description_' + lang];
          });
          if (!this.value.some(currentItem => currentItem.id === entity.id)) {
            this.value.push(entity);
          }
        });
        this._onModelChanged(this.value);
      }
    });
  }

  private handleChosenEntities(): void {
    // todo _ids and stuff
    this._entitiesService.entitiesChosen$.subscribe((entityResponse: { entities: Entity[], apiUrl: string }) => {

      if (entityResponse.apiUrl === this.field.apiUrl) {
        // update the value
        entityResponse.entities.forEach(entity => {
          if (!this.value.some(en => en.id === entity['id'])) {
            this.value.push(entity);
          }
        });

        this._onModelChanged(this.value);
      }
    });
  }

}
